import React from 'react';
import { Box } from '@mantine/core';
import { Collection } from '@common/merch';
import { CategorySelector } from './CategorySelector';

interface CategorySelectorsProps {
  collections: Collection[];
  activeCollection?: string | null;
  onCollectionClick?: (collectionId: string, collectionName?: string) => void;
}

export const CategorySelectors: React.FC<CategorySelectorsProps> = ({
  collections,
  activeCollection,
  onCollectionClick
}) => {
  return (
    <Box style={{ flex: 1 }}>
      {collections.map((collection) => (
        <CategorySelector
          key={collection.id}
          name={collection.title}
          isActive={activeCollection === collection.id}
          onClick={() => onCollectionClick?.(collection.id, collection.title)}
        />
      ))}
    </Box>
  );
};
